import { useEffect, useState } from "react";
import styled from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { actions, useAppDispatch, useAppSelector } from "../../../../../redux";
import { Modal } from "../../../../Common";
import { FlexColumn, FlexRow } from "../../../../Common/Styles";
import { Counter } from "./Counter";
import { FollowersFollowingProps } from "./FollowersFollowing";
import { FollowModalContent } from "./ModalContent";
import { FollowModalHeading } from "./ModalHeading";

export const FollowersFollowing = () => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [type, setType] = useState<FollowersFollowingProps.Type>("none");

  const idPrefix = "followerFollowing";
  const fieldName = `Search`;
  const searchInputId = `${idPrefix}_${fieldName}`;

  const { followers_count, following_count, getFollowCounts_API_STATUS } =
    useAppSelector((state) => state.connections);

  //#region UseEffects
  useEffect(() => {
    if (getFollowCounts_API_STATUS !== "idle") return;

    API_CALLS.CONNECTIONS.getFollowCounts();
  }, [getFollowCounts_API_STATUS]);
  useEffect(() => {
    !showModal && setFilterText("");
    dispatch(actions.connections.resetSearchUsersIncludingData());
  }, [showModal, dispatch]);
  //#endregion

  const handleCounterClick = (type: FollowersFollowingProps.Type) => {
    setShowModal(true);
    setType(type);
  };

  const inputFieldProps: FollowersFollowingProps.InputFieldProps = {
    idPrefix,
    fieldName,
    searchInputId,
  };
  const contentProps: FollowersFollowingProps.FollowModalContent = {
    showModal,
    type,
    filterText: filterText.toLowerCase(),
    ...inputFieldProps,
  };
  const headingProps: FollowersFollowingProps.FollowModalHeading = {
    ...contentProps,
    setFilterText,
  };

  return (
    <FlexRow $gapInPx={0}>
      {showModal && (
        <Modal
          from="followers-following"
          type="Pages"
          showCloseButton={true}
          setCloseButton={setShowModal}
          closeModalOnClickOutside={showModal}
          maxHeight={500}
          minHeight={500}
          minWidth={352}
          maxWidth={352}
          stretchToFullWidth={false}
          modalSize="small"
          padding={46}
        >
          <ModalContainer className="follow-modal-container" $gapInPx={8}>
            <FollowModalHeading {...headingProps} />
            <FollowModalContent {...contentProps} />
          </ModalContainer>
        </Modal>
      )}
      <Counter
        title="Followers"
        count={followers_count}
        onClick={() => handleCounterClick("followers")}
      />
      <Counter
        title="Following"
        count={following_count}
        onClick={() => handleCounterClick("following")}
      />
    </FlexRow>
  );
};

const ModalContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
